/**
 * IF11 MB4 Toll-Free Number and Fax Number on the member dashboard profile
 * card (CMP Accelerator ACC:178-183, formatters ACC:3369-3381): toll-free
 * "1-800-555-0142" (a leading 1 is added), fax "(705) 288-6061". The backend
 * stores digits only.
 */
export const getCmpPhoneDigits = (value: string | null | undefined) => (value || "").replace(/\D/g, "");

export const formatCmpTollFree = (value: string | null | undefined) => {
    let d = getCmpPhoneDigits(value);
    if (d.length > 0 && d[0] !== "1") d = `1${d}`;
    d = d.slice(0, 11);
    return [d.slice(0, 1), d.slice(1, 4), d.slice(4, 7), d.slice(7, 11)].filter(Boolean).join("-");
};

export const formatCmpFax = (value: string | null | undefined) => {
    const d = getCmpPhoneDigits(value).slice(0, 10);
    if (d.length > 6) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    if (d.length > 3) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    if (d.length > 0) return `(${d}`;
    return "";
};
